import { z } from "zod";

export const hallsScheme = z.object({
  halls: z.string().min(1),
});

export type HallsFormScheme = z.infer<typeof hallsScheme>;
